import { render } from "./ManualArea.vue?vue&type=template&id=990f4a76"
import script from "./ManualArea.vue?vue&type=script&lang=js"
export * from "./ManualArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__